export default __webpack_public_path__ + "static/dashboard-v2-a600e2ed7e5383dda403dc9acc5319ca.jpg";